import ajax from './ajax';

export const global = {
  /**
   * 获取全局配置信息
   * @param {String} domain 请求域名
   */
  siteConfig(domain, agencyId = 0, isApi = 0) {
    agencyId = agencyId || '';
    isApi = isApi || '';
    //return ajax.get('/config'); //mock版
    return ajax.get(
      `/api/pc/homePage/findDataByrealmName?realmName=${domain}&agencyId=${agencyId}&isApi=${isApi}`,
      // `/api/pc/homePage/findDataByrealmName?realmName=hyt.beegoedu.com&agencyId=${agencyId}&isApi=${isApi}`
    );
  },

  /**
   * 获取导航数据
   * @param {int} agencyId 机构Id
   */
  getNavList(agencyId) {
    return ajax.get(`/api/pc/homePage/getMenuListByAgencyId/${agencyId}`);
  },
  /**
   * 获取导航下拉列表
   * @param {*} agencyId -机构Id
   */
  getDropNavList(agencyId) {
    return ajax.get(`/api/pc/getAllCatogoryData/${agencyId}`);
  },
};

export const home = {
  /**
   * 获取Banner
   * @param {Number} agencyId
   * @param {Number} type 1首页  2精品课程（商品列表页）
   */
  getBannerList(agencyId, type) {
    //return ajax.get('/home/getBannerList'); //mock版
    return ajax.get(`/api/pc/homePage/getAdvertListByAgencyId/${agencyId}`, {
      type,
    });
  },
  // getHotProductList() {
  //     return ajax.get('/home/getHotProductList') //mock版
  // },
  /**
   * 取首页模板数据
   * @param {int} agencyId - 机构Id
   */
  getThemeData(agencyId) {
    return ajax.get(`/api/pc/homePage/findAllByUserId/${agencyId}`);
  },
  /**
   * 获取底部友情链接
   * @param {*} agencyId
   */
  getFooterLink(agencyId) {
    return ajax.get(`/api/pc/homePage/getFooterlinkListByAgencyId/${agencyId}`);
  },
  /**
   *
   * @param {*} agencyId
   * @param {*} majorId
   */
  getProductList(agencyId, majorId) {
    return ajax.get(
      `/api/pc/homePage/findProductListByMajorId/${majorId}/${agencyId}`,
    );
  },
  /**
   * 获取新闻列表（随机新闻，换一批）
   * @param {Number} agencyId 机构ID
   */
  getNewsList(agencyId) {
    return ajax.get(`/api/pc/homePage/changeNews/${agencyId}`);
  },
};

export const mall = {
  /**
   * 精品课程条件
   * @param {Object} filter 条件{}
   */
  getFilterList(filter) {
    return ajax.post(`/api/pc/course/qualityCourseNva`, filter);
  },

  /**
   * 精品课程
   * @param {Object} filter 条件{}
   */
  getProductList(filter) {
    return ajax.post(`/api/pc/course/qualityCourseList`, filter);
  },
  /**
   * 自选精品课程
   * @param {Object} filter 条件{}
   */
  getProductDiyList(filter) {
    return ajax.post(`/api/pc/course/myQualityCourseList`, filter);
  },
  /**
   * 获取专题页信息
   * @param {*} agencyId 机构Id
   * @param {*} majorId 专业Id
   */
  getMajorInfo(agencyId, majorId) {
    return ajax.get(`/api/pc/getThematicDataByMajorId/${majorId}/${agencyId}`);
  },
  /**
   * 获取信息采集表单数据
   * @param {Number} agencyId 机构ID
   */
  getFormData(agencyId) {
    return ajax.get(`/api/pc/getTemplate/${agencyId}`);
  },
  /**
   * 保存信息采集表单数据
   * @param {Object} data {
   *  agencyId-机构ID
   *  templateid-表单模板ID
   *  projectname - 导航名称
   *  scence - 场景 传1
   *  loginusername - 未登录传空值
   *  templatedatas:[],数据，模板字段数据，由上获取的表单数据
   * }
   * @returns
   */
  saveFormData(data) {
    return ajax.post(`/api/pc/saveTemplateRecord`, data);
  },
  /**
   * 获取专业位置路径
   * @param {*} majorId 专业ID
   */
  getMajorLocation(majorId) {
    return ajax.get(`/api/pc/getNameByMajorId/${majorId}`);
  },
  /**
   * 获取专业商品列表(已调整，不在使用当前接口，变为下方接口)
   * @param {Number} agencyId 机构ID
   * @param {String} majorId 专业ID
   */
  getMajorProductList(agencyId, majorId) {
    return ajax.get(`/api/pc/findByMajorId/${majorId}/${agencyId}`);
  },
  /**
   * 获取专业下课程列表
   * @param {Number} agencyId 机构ID
   * @param {String} majorId 专业ID
   */
  getMajorCourseList(agencyId, majorId) {
    return ajax.get(`/api/pc/findCourseListByMajorId/${majorId}/${agencyId}`);
  },
  /**
   * 获取课程班型列表
   * @param {Number} agencyId 机构Id
   * @param {String} majorId 专业Id
   * @param {String} courseId 课程Id
   */
  getCourseSpecialList(agencyId, majorId, courseId) {
    return ajax.get(
      `/api/pc/findSpecialByParams/${majorId}/${agencyId}/${courseId}`,
    );
  },
  /**
   * 获取专题页专业班型商品列表
   * @param {*} agencyId 机构Id
   * @param {*} specialId 班型Id
   * @param {*} majorId 专业Id
   */
  getMajorSpecialProductList(agencyId, specialId, majorId) {
    return ajax.get(
      `/api/pc/findBySpecialIdAndagencyId/${specialId}/${agencyId}/${majorId}`,
    );
  },
  /**
   * 获取课程目录（with CourseId）
   * @param {String} courseId 课程Id
   * @param {Number} cstId 课程班型Id
   * @param {Number} type 类型 1普通  2串讲
   */
  getCourseCatalog(courseId, cstId, type, userId, agencyId) {
    cstId = cstId || 0;
    type = type || 1;
    userId = userId || 0;
    agencyId = agencyId || 0;
    return ajax.get(
      `/api/pc/findCourseCatBycourseId/${courseId}/${cstId}/${type}`,
      { userId, agencyId },
    );
  },
  /**
   * 获取课程信息
   * @param {String} courseId 课程ID
   * @param {Number} userId 用户ID
   * @param {Number} agencyId 机构ID
   */
  getCourseInfo(courseId, userId, agencyId, productId) {
    productId = productId || 0;
    return ajax.get(`/api/pc/getcoursedetail/${courseId}/${userId}`, {
      agencyId,
      productId,
    });
  },
  /**
   * 获取商品信息
   * @param {Number} agencyId 机构ID
   * @param {Number} productId 商品ID
   * @param {Number} userId 用户Id，用于判断是否购买，未登录传0
   */
  getProductInfo(agencyId, productId, userId) {
    return ajax.post(`/api/pc/course/qualityCourseDetail`, {
      agencyId,
      productId,
      userId,
    });
  },
  /**
   * 获取商品课程资料信息
   * @param {productid} productid 商品Id
   */
  productCourseDetail(productid) {
    return ajax.get(`/api/pc/course/productCourseDetail`, { productid });
  },

  /**
   * 获取课程资料列表
   * @param {String} courseId
   */
  getCourseWare(courseId, userId) {
    return ajax.get(`/api/pc/getCoursewareListByCourseId/${courseId}`, {
      userId,
    });
  },
  /**
   * 获取考前密训资格
   * @param {String} courseId
   * @param {String} userid
   */
  getTraningQuanlification(courseId, userid) {
    return ajax.get(`/api/pc/getUserCourseSecret/${courseId}/${userid}`);
  },
  /**
   * 获取考前密训目录
   * @param {String} reviewid
   * @param {String} cstid
   */
  getSecretCatalogue(reviewid, cstid) {
    return ajax.get(`/api/pc/secretCourse/${reviewid}/${cstid}`);
  },
  /**
   * 获取全国地区省份
   */
  getAddress(agencyId) {
    return ajax.get(`/api/pc/course/address`, { agencyId });
  },
};

//购买
export const order = {
  /**
   * 获取要购买的商品信息及优惠相关息信
   * @param {*} productId 商品ID
   * @param {*} buyType 购买类型（1全程，2精讲，3串讲）
   * @param {*} userId 用户ID
   */
  getProductInfoWithBuy(productId, buyType, userId) {
    return ajax.get(`/order/cart/${userId}/${productId}/${buyType}`);
  },
  /**
   * 创建用户订单
   * @param {Object} data 数据{userId,productId,type,memo//使用积分,userRemark//用户备注}
   */
  createOrder(data) {
    return ajax.post(
      `/order/buy/${data.userId}/${data.productId}/${data.type}`,
      {
        Memo: data.memo,
        UserRemark: data.userRemark,
        agreementId: data.agreementId,
        agreementRecordId: data.agreementRecordId,
      },
    );
  },
  /**
   * 获取机构支付方式
   * @param {Number} agencyId 机构ID
   */
  getPaymentType(agencyId) {
    return ajax.get(`/order/alltype/${agencyId}`);
  },
  /**
   * 支付宝付款
   * @param {Number} userId 用户Id
   * @param {String} orderNo 订单号
   */
  paymentWithAlipay(userId, orderNo) {
    return ajax.get(`/payment/alipay/${userId}/${orderNo}`);
  },
  /**
   * 银联付款
   * @param {Number} userId 用户Id
   * @param {String} orderNo 订单号
   */
  paymentWithUnion(userId, orderNo) {
    return ajax.get(`/payment/tgpay/${userId}/${orderNo}`);
  },
  /**
   * 微信支付
   * @param {Number} userId 用户Id
   * @param {String} orderNo 订单号
   */
  paymentWithWx(userId, orderNo) {
    return ajax.get(`/payment/wxpay/${userId}/${orderNo}`);
  },
  /**
   * 获取订单支付状态
   * @param {String} orderNo 订单号
   */
  getOrderPayStatus(orderNo) {
    return ajax.get(`/order/status/${orderNo}`);
  },
  /**
   * 获取引流推广码
   * @param {Number} agencyId 机构ID
   * @returns
   */
  getAttractQrCode(agencyId) {
    return ajax.get(`/payment/attract/${agencyId}`);
  },
  /**
   * 教材订单通知数量
   * @param {Number} userId
   * @returns
   */
  getMaterialOrderCount(userId) {
    return ajax.get(`/api/pc/materialOrderNotice/${userId}`);
  },
  /**
   * 获到教材订单列表
   * @param {Number} userId
   * @returns
   */
  getMaterialOrders(userId) {
    return ajax.get(`/api/pc/userMaterialOrder/${userId}`);
  },
  /**
   * 获取教材订单详情（地址）
   * @param {Number} id OrderId
   * @returns
   */
  getMaterialOrderDetail(id) {
    return ajax.get(`/api/pc/materialOrderDetail/${id}`);
  },
  /**
   * 更新订单详情（地址）
   * @param {Object} params
   * @returns
   */
  editMaterialAddress(params) {
    return ajax.post(`/api/pc/editMaterialOrder`, params);
  },
  /**
   * 获取教材子订单（查看教材）
   * @param {Number} id
   * @returns
   */
  getMaterialSubOrder(id) {
    return ajax.get(`/api/pc/userMaterialOrder/subOrder/${id}`);
  },

  /**
   * 查看商品是否需求签约
   * @param {Number} userid
   * @param {Number} productid
   * @returns
   */
  getBuyCheckAgreement(userid, productid) {
    return ajax.get(`/order/buy/check/agreement/${userid}/${productid}`);
  },

  /**
   * 查看是否签约完成
   * @param {Number} agreementId
   * @param {Number} orderId
   * @param {Number} type
   * @param {Number} t
   * @param {Number} userId
   * @returns
   */
  getIsCheckAgreement(data) {
    return ajax.get(`/agreement/order/status/check`, data);
  },
};

//学习相关
export const study = {
  /**
   * 获取用户班型列表
   * @param {String} courseId 课程ID
   * @param {Number} userId 用户ID
   */
  getCourseSpecial(courseId, userId) {
    return ajax.get(
      `/api/pc/findSpecialByCourseIdAndUserId/${courseId}/${userId}`,
    );
  },
  /**
   * 获取用户课程学习目录
   * @param {int} umcId 用户课程Id
   * @param {String} courseId 课程Id
   * @param {int} cstId 班型ID
   * @param {int} type 目录类型（普通OR串讲）
   */
  getCourseCatalog(umcId, courseId, cstId, type) {
    cstId = cstId || 0;
    type = type || 1;
    return ajax.get(
      `/api/pc/getcoursechapter/${umcId}/${courseId}/${cstId}/${type}`,
      {},
    );
  },
  /**
   * 获取课程目录详细信息
   * @param {*} catId 目录ID
   */
  getCatalogInfo(catId) {
    return ajax.get(`/api/pc/findCourseCatBypptId/${catId}`);
  },
  /**
   * 获取章节练习目录列表
   * @param {Number} userId 用户Id
   * @param {String} courseId 课程Id
   * @param {Number} cstId 课程班型Id
   */
  getPracticeCatalogList(userId, courseId, cstId) {
    return ajax.get(
      `/api/pc/getPracticeListByCstId/${cstId}/${userId}/${courseId}`,
    );
  },
  /**
   * 获取视频是否收藏
   * @param {Number} umcId
   * @param {Number} pptId
   */
  getVideoIsFav(umcId, pptId) {
    return ajax.get(`/api/pc/isCollectionByPptIdAndUmcId/${pptId}/${umcId}`);
  },
  /**
   * 添加||删除视频收藏
   * @param {Number} umcId
   * @param {Number} pptId
   */
  addOrDelVideoFav(umcId, pptId, userId, courseId) {
    return ajax.post(
      `/api/pc/editmycollectionexer/${userId}/${pptId}/${umcId}`,
      { courseId },
    );
  },
  /**
   * 获取播放信息（主要视频播放次数）with catId
   * @param {Number} umcId
   * @param {Number} catId 目录
   */
  getVideoPlayInfo(umcId, catId) {
    return ajax.get(`/api/pc/getpptfilepath/${catId}/${umcId}`);
  },
  /**
   * 获取串讲播放信息（主要取视频播次数）
   * @param {Number} umcrId 串讲记录Id
   * @param {Number} pptId 视频Id
   */
  getReviewPlayInfo(umcrId, pptId) {
    return ajax.get(`/api/pc/getreviewpptfilepath`, { umcrId, pptId });
  },
  /**
   * 设置精讲视频播放完成
   * @param {Numbewr} umcId
   * @param {Number} catId 目录Id
   * @param {Number} over 1-完成时调用，0-其它
   */
  setVideoPlayOverWithPpt(umcId, catId, over) {
    over = over || 0;
    return ajax.get(`/api/pc/setpptfinishflag/${umcId}/${catId}`, {
      isLook: over,
    });
  },
  /**
   * 获取模考列表
   * @param {int} umcId 用户课程Id
   * @param {String} courseId 课程Id
   * @param {int} page 页码
   */
  getSimExamList(umcId, courseId, page) {
    return ajax.get(`/api/pc/getsimexamlist/${umcId}/${courseId}/${page}`);
  },
  /**
   * 获取用户模考记录列表
   * @param {*} umcId
   * @param {*} page
   */
  getSimExamHistoryList(umcId, page) {
    return ajax.get(`/api/pc/getsimexamhistorylist/${umcId}/${page}`);
  },
  /**
   * 获取串讲状态
   * @param {Number} umcId 用户课程ID
   * @param {String} courseId 课程ID
   * @param {Number} cstId 课程班型ID
   */
  getReviewStatus(umcId, courseId, cstId) {
    return ajax.get(`/api/pc/getreviewstatus/${umcId}/${courseId}`, { cstId });
  },
  /**
   * 获取串讲视频及练习题列表
   * @param {Number} umcrId 用户串讲记录Id
   */
  getReviewVideoOrExercisList(umcrId) {
    return ajax.get(`/api/pc/getreviewpptlist/${umcrId}`);
  },
  /**
   * 设置串讲视频播放完成
   * @param {Numbewr} umcrId
   * @param {Number} pptId 视频Id
   */
  setVideoPlayOverWithReview(umcrId, pptId) {
    return ajax.post(`/api/pc/setReviewPptFinishflag/${umcrId}/${pptId}`);
  },
  /**
   * 获取直播列表
   * @param {Number} userId 用户ID
   * @param {String} keywords 查询关健词
   * @param {Number} page 当前页
   * @param {String} isOpen 是否全部直播（全部直播传值即可，不是的传空值）
   * @param {String} isTry 是否试用账号（传1为试用，否则为非试用）
   */
  getLiveList(userId, keywords, page, isOpen, isTry) {
    //return ajax.get(`/api/pc/getlivelist/${courseId}?userid=${userId}`);（已废弃，不需要了）
    return ajax.get(`/api/pc/getUserliveinfoSearch`, {
      userId,
      keywords,
      page,
      isOpen,
      isTry,
    });
  },
  /**
   * 获取直播场次列表
   * @param {String} channelId 频道ID
   * @param {Number} agencyId 机构ID
   * @param {String} keywords 关键词
   * @param {Number} page 页码
   * @returns
   */
  getLiveSceneList(channelId, agencyId, keywords, page) {
    return ajax.get(
      `/api/pc/live/list/byChannelId?channelId=${channelId}&agencyId=${agencyId}&keywords=${keywords}&page=${page}`,
    );
  },
  saveLiveTime(userId, channeld, liveId) {
    return ajax.post(`api/qz/saveLiveTime`, {
      userId,
      channeld,
      liveId,
    });
  },
  /**
   * 获取直播详情
   * @param {Number} liveId 直播Id
   * @param {Number} userId 用户Id
   */
  getLiveInfo(liveId, userId, nickName, v) {
    userId = userId || 0;
    nickName = nickName || '';
    return ajax.get(`/api/pc/getLiveDetails/${liveId}`, {
      userId,
      nickName,
      v,
    });
  },
  getLiveParams(channelId, userId) {
    userId = userId || 0;
    return ajax.get('/api/pc/getLiveParams', { channelId, userId });
  },
  /**
   * 获取直播签名（百家云）
   * @param {Object} params
   * @returns
   */
  getLiveSign(params) {
    return ajax.get(`api/pc/getViewLiveSign`, params);
  },
  /**
   * 获取回放token（百家云）
   * @param {Object} params
   * @returns
   */
  getPlaybackToken(params) {
    return ajax.get(`api/pc/getLivePlaybackToken`, params);
  },
  /**
   * 获取播放授权码
   * @param {String} videoId 视频vid
   */
  getVideoSafeCode(videoId) {
    return ajax.get(`/api/pc/findVideoByPvideoId/${videoId}`);
  },
  getVideoSignSecret(videoId) {
    return ajax.get(`/api/pc/getPlaySignSecret`, { vid: videoId });
  },
  getVideoPlayToken(videoId) {
    return ajax.get(`/api/pc/getPlayToken`, { vid: videoId });
  },
  /**
   * 获取学习统计信息
   * @param {Number} userId 用户ID
   * @param {String} courseId 课程ID
   */
  getStudyStatistics(userId, courseId) {
    return ajax.get(`/api/pc/getpracprogressbyumcidnew`, {
      userId,
      courseId,
    });
  },
  /**
   * 获取用户课程信息
   * @param {Number} umcId
   */
  getUmcInfo(umcId) {
    return ajax.get(`/api/pc/getUmcData/${umcId}`);
  },
  /**
   * 获取课后练习题列表
   * @param {Number} umcId
   * @param {Number} catId 目录Id
   */
  getVideoExerList(umcId, catId) {
    return ajax.get(`/api/pc/genpracallbycatidbychapter/${umcId}/${catId}`);
  },
  /**
   * 保存课后练习（当前主要用于加入错题本）
   * @param {Number} umcId
   * @param {Number} catId 目录Id
   * @param {Number} userId 用户Id
   * @param {Object->String} result 做题结果[{exerId:226,isRight:0}]
   */
  saveVideoExer(umcId, catId, userId, result, courseId) {
    return ajax.post(`/api/pc/saveWrongCollectionByParams`, {
      umcId,
      catId,
      userId,
      result,
      courseId,
    });
  },
  /**
   * 获取章节练习进度
   * @param {Number} umcId
   * @param {Number} catId 节的目录ID
   */
  getPracticeProgress(umcId, catId) {
    return ajax.get(`/api/pc/getStudySchedule/${umcId}/${catId}`);
  },
  /**
   * 获取章节练习题列表
   * @param {Number} umcId
   * @param {Number} catId 目录ID
   */
  getPracticeList(umcId, catId) {
    return ajax.get(`/api/pc/getChapterExerciseList/${umcId}/${catId}`);
  },
  /**
   * 保存章节练习（中途）
   * @param {Object} data
   */
  savePractice(data) {
    return ajax.post(`/api/pc/newsavechapterpracrec`, data);
  },
  /**
   * 提交章节练习（交卷）
   * @param {Object} data
   */
  postPractice(data) {
    return ajax.post(`/api/pc/newpostexerrecbychapter`, data);
  },
  /**
   * 获取模考记录ID（srId）,没有会生成新的，全局跟踪模考。
   * @param {Number} umcId
   * @param {Number} simId 模考ID
   */
  getSimExamRecordId(umcId, courseId, simId) {
    return ajax.get(`/api/pc/gensimexamrecid/${umcId}/${simId}`, { courseId });
  },
  /**
   * 获取模考练习题列表(未使用)
   * @param {Number} umcId 用户课程ID
   * @param {Number} simId 模考ID
   */
  getSimExamExerciseList(umcId, simId) {
    return ajax.get(`/api/pc/gensimexamrecall/${umcId}/${simId}`);
  },
  /**
   * 获取模考练习题列表(SrId)
   * @param {Number} umcId
   * @param {Number} srId 模考记录ID
   * @param {Number} histoy 历史0 新做-2;
   */
  getSimExamExerciseListWithSrId(umcId, srId, history = -2) {
    return ajax.get(
      `/api/pc/gensimexamreListBysrId/${umcId}/${srId}/${history}`,
    );
  },
  /**
   * 获取模考练习记录详情
   * @param {Number} params 模考记录ID
   */
  getSimExamHistoryInfo(params) {
    return ajax.get(`/api/pc/genSimexamRecord`, params);
  },
  /**
   * 中途保存模考记录
   * @param {Object} data 数据对象集
   */
  saveSimExamRecord(data) {
    return ajax.post(`/api/pc/newsavesimexamrec`, data);
  },
  /**
   * 提交模考做题结果（交卷）
   * @param {Object} data 数据对象集
   */
  postSimExamRecord(data) {
    return ajax.post('/api/pc/newpostexerrecbysimexam2', data);
  },
  /**
   * 获取串讲题组信息及题目列表
   * @param {*} umcrId
   * @param {*} regId 串讲题组ID
   */
  getReviewExerciseList(umcrId, regId) {
    return ajax.get(`/api/pc/genreviewprac/${umcrId}/${regId}/1`);
  },
  /**
   * 中途保存串讲练习
   * @param {Object} data
   */
  saveReviewPractice(data) {
    return ajax.post(`/api/pc/newsavereviewpracrec`, data);
  },
  /**
   * 提交串讲练习（交卷）
   * @param {Object} data
   */
  postReviewPractice(data) {
    return ajax.post(`/api/pc/newpostexerrecbyreview`, data);
  },
  /**
   * 获取错题本列表
   * @param {Number} umcId
   */
  // getWrongList(umcId, courseId, userId) {
  //   return ajax.get(`/api/pc/genwrongrecall/${umcId}/-2`, { courseId, userId });
  // },
  getWrongList(umcId, params) {
    return ajax.get(`/api/pc/genwrongrecall/${umcId}/${params.page}`, params);
  },
  /**
   * 从错题本中删除
   * @param {Object} data
   */
  deleteWrongExercise(data) {
    return ajax.post(`/api/pc/delwrongexer`, data);
  },
  /**
   * 获取收藏的练习题
   * @param {Number} umcId
   */
  getFavExercise(umcId) {
    return ajax.get(`/api/pc/getmycollectionpraclist/${umcId}`);
  },
  /**
   * 添加||删除习题收藏
   * @param {Number} umcId
   * @param {Number} exerId 练习题Id
   */
  addOrDelExerciseFav(umcId, exerId, userId, courseId) {
    return ajax.post(`/api/pc/editmycollectionExers/${umcId}/${exerId}`, {
      userId,
      courseId,
    });
  },
  /**
   * 获取收藏的视频
   * @param {Number} umcId
   */
  getFavVideo(umcId) {
    return ajax.get(`/api/pc/getmycollectionpptlist/${umcId}`);
  },
  /**
   * 获取练习题详情
   * @param {Number} exerId 练习题ID
   */
  getExerciseInfo(exerId) {
    return ajax.get(`/api/pc/getExercisestore/${exerId}`);
  },
  /**
   * 获取视频提问列表
   * @param {Number} userId 用户Id
   * @param {Number} pptId 视频Id
   */
  getVideoQuestionList(userId, pptId) {
    return ajax.get(`/api/pc/questions/getpptquestions/${userId}/${pptId}`);
  },
  /**
   * 获取练习师的提问列表
   * @param {Number} userId 用户Id
   * @param {Number} exerId 练习题Id
   */
  getExerciseQuestionList(userId, exerId) {
    return ajax.get(`/api/pc/questions/getexerquestions/${userId}/${exerId}`);
  },
  /**
   * 获取提问时的Location信息，三个参数只会有一个，其它则为0
   * @param {Number} simId 模考Id
   * @param {Number} catId 目录Id
   * @param {Number} regId 串讲题组Id
   * @param {Number} umcId umcId
   * @param {Number} type 类型（1-视频 0or其它-练习题）有catId时才用得到
   */
  getAskLocation(simId, catId, regId, umcId, type) {
    return ajax.get(`/api/pc/getCatNameByParams/${simId}/${catId}/${regId}`, {
      umcId,
      type,
    });
  },
  /**
   * 保存用户的提问
   * @param {*} data 数据
   */
  saveUserQuestion(data) {
    return ajax.post(`/api/pc/questions/newsaveuserquestion`, data);
  },
  /**
   * 保存用户对提问的评论
   * @param {*} data
   */
  saveUserComment(data) {
    return ajax.post(`/api/pc/saveusercomment`, data);
  },
  /**
   * 修改教师评论内容
   * @param {Object} data
   */
  modifyUserComment(data) {
    return ajax.post(`/api/pc/questions/updateTeacherComment`, data);
  },
  /**
   * 保存（取消）用户点赞
   * @param {Number} qId
   * @param {Number} userId
   */
  saveUserGoods(qId, userId) {
    return ajax.post(`/api/pc/questions/saveusergoodnum/${qId}/${userId}`);
  },

  /**
   * 获取机构介绍
   * @param {Number} userId 机构Id
   */

  getselectdata(userId, keywords) {
    return ajax.get(
      `/api/pc/getactivemajorcourse/${userId}?keywords=${keywords}`,
    );
  },
  /**
   * 获取主观题目AI成绩
   * @param {Object} query 条件
   * @returns
   */
  getAIScore(query) {
    return ajax.post(`/api/pc/scoringMethod`, query);
  },
  /**
   * 提交答疑内容到AI存储库
   * @param {Object} params {qValue,aValue}
   * @returns
   */
  addAiRepository(params) {
    return ajax.post(`/api/pc/ai/qa/repository/add`, params);
  },
};

//教师
export const teacher = {
  /**
   * 获取教师筛选条件列表
   * @param {Object} filter 条件
   */
  getFilterList(filter) {
    return ajax.get(`/api/pc/teacher/teachaerListNva`, filter);
  },
  /**
   * 获取教师列表
   * @param {Object} filter 查询条件
   */
  getTeacherList(filter) {
    return ajax.post('/api/pc/teacher/list', filter);
  },
  /**
   * 获取教师详情及任课信息
   * @param {Number} id 教师ID
   */
  getTeacherInfo(id, agencyid) {
    return ajax.post(`/api/pc/teacher/teacherDetails/${id}`, { agencyid });
  },
};

//文章新闻
export const article = {
  /**
   * 获取分类
   * @param {Number} agencyId
   * @param {Number} parentId
   */
  getCatalogList(agencyId, parentId) {
    return ajax.get(`/api/pc/article/newsNva`, {
      agencyId,
      parentId,
    });
  },
  /**
   * 获取分类下文章
   * @param {Number} catalogId 分类ID
   */
  getArticleList(catalogId, page, pageSize) {
    return ajax.get(`/api/pc/article/list`, {
      articlecategoryId: catalogId,
      page,
      pageSize,
    });
  },
  /**
   * 获取文章详情
   * @param {Number} articleId 文章ID
   */
  getArticleInfo(articleId) {
    return ajax.get(`/api/pc/article/articleDetails`, { articleId });
  },
  getTopicArticleList(majorId, agencyId) {
    return ajax.get(
      `/api/pc/getMajorArticles/${majorId}/${agencyId}?name=list`,
    );
  },
  /**
   * 获取机构介绍
   * @param {Number} agencyId 机构Id
   */
  getAgencyIntro(agencyId) {
    return ajax.get(`/api/pc/agencyintro/${agencyId}`);
  },
};

//账户
export const account = {
  /**
   * 注册
   * @method userRegister
   * @param {Object} data - 对象
   * @return {返回值类型} 返回值说明
   */
  userRegister(data) {
    return ajax.post('/api/pc/userregister', data);
  },

  /**
   * 登录
   * @method userLogin
   * @param {Object} data - 对象
   * @return {返回值类型} 返回值说明
   */
  userLogin(data) {
    return ajax.post('/api/pc/login', data);
  },
  /**
   * 检测同一手机号是否有多个账号
   * @param {Number} agencyId 机构Id
   * @param {String}} mobile 手机号
   */
  checkUsernameWithCellphone(agencyId, mobile) {
    return ajax.get('/api/pc/getUserNameByMobile', {
      agencyId,
      mobile,
    });
  },
  /**
   * 手机验证码登录
   * @param {Object} data {mobile-手机号，verifyCode-验证码}
   */
  phoneCodeLogin(data) {
    return ajax.post(`/api/pc/verifyCodeLogin`, data);
  },
  /**
   * 获取手机验证码
   * @param {*} mobile 手机号
   * @param {*} userid 用户ID，非注册时使用，注册时传0
   * @param {*} type 1表示注册，其它值忽略。
   * @param {*} agencyId 机构ID，主要注册时使用。
   */
  getPhoneCode(mobile, userId, type, agencyId, randomNum, imageCode) {
    let uid = 0;
    if (userId) uid = userId;
    let t = type || 0;
    agencyId = agencyId || 0;
    return ajax.get(`/api/pc/sendverifycode/${uid}/${mobile}`, {
      type: t,
      agencyId,
      randomNum,
      verify: imageCode,
    });
  },
  /**
   * 获取手机验证码
   * @param {Object} data {mobile:手机号,imgCode:图形码,randomNum:随机码}
   */
  getPhoneCodeWithImageCode(data) {
    return ajax.post(`/api/pc/verityImgCode`, data);
  },
  /**
   * 检测手机验证码是否正确
   * @param {String} mobile
   * @param {String} verifyCode
   */
  checkPhoneCode(mobile, verifyCode) {
    return ajax.get(`/api/pc/verifyMobile`, {
      mobile,
      verifyCode,
    });
  },
  /**
   * 重置用户密码
   * @param {String} mobile
   * @param {String} verifyCode
   * @param {String} password
   * @param {String} enterPassword
   * @param {String} agencyId 机构ID，上一步中返回的机构ID，非全局机构ID
   * @param {String} username 用户名，上一步中返回的，非全局
   */
  resetPassword(
    mobile,
    verifyCode,
    password,
    enterPassword,
    agencyId,
    username,
  ) {
    return ajax.post(`/api/pc/saveUserPassWord`, {
      mobile,
      verifyCode,
      passWord: password,
      entPassWord: enterPassword,
      mobileagencyid: agencyId,
      mobileusername: username,
    });
  },
  /**
   * 绑定（重置）用户手机号
   * @param {Number} userId
   * @param {String} mobile
   * @param {String} verifyCode
   */
  bindCellphone(userId, mobile, verifyCode) {
    return ajax.post(`/api/pc/saveMobile`, {
      mobile,
      userId,
      verifyCode,
    });
  },
  /**
   * 获取直播登录类型
   * @param {Number} liveId
   */
  getLiveLoginType(liveId) {
    return ajax.get(`/api/pc/valifyLiveVerifyType/${liveId}`);
  },
  /**
   * 直播登录
   * @param {Object} data
   */
  checkLiveLogin(data) {
    return ajax.post(`/api/pc/liveLogin`, data);
  },
  /**
   * 试用登录
   * @param {Number} agencyId
   */
  trialLogin(agencyId) {
    return ajax.get(`/api/pc/loginTest`, {
      agencyId,
    });
  },
  /**
   * 获取签名
   * @param {Number} userId 用户ID
   */
  getSign(userId) {
    return ajax.get(`/api/pc/getUsersSign/${userId}`);
  },
  /**
   * 通过token获取用户信息
   * @param {String} token
   * @returns
   */
  getUserInfo(token) {
    return ajax.get(`/api/pc/tokenLogin?token=${token}`);
  },
};

//会员中心
export const user = {
  /**
   * 我的课程
   * @method getUserCourseList
   * @param {Number} userid - 用户id
   * @return {返回值类型} 返回值说明
   */
  getUserCourseList(userId, keywords) {
    keywords = keywords || '';
    return ajax.get(`/api/pc/getactivemajorcourse/${userId}`, { keywords });
  },

  /**
   * 我的问题
   * @method getMyQuestion
   * @param {Number} userid - 用户id
   * @return {返回值类型} 返回值说明
   */
  getMyQuestion(userId) {
    return ajax.get(`/api/pc/questions/getmyquestion/${userId}`);
  },
  /**
   * 删除问题
   * @param {Number} qId
   */
  deleteMyQuestion(qId) {
    return ajax.post(`/api/pc/questions/delmyquestion/${qId}`);
  },
  /**
   * 获取提问的详情
   * @param {Number} userId 用户ID
   * @param {Number} qId 问题ID
   */
  getQuestionInfo(userId, qId, isTeacher) {
    let isT = isTeacher || 0;
    return ajax.get(
      `/api/pc/questions/getquestiondetail/${userId}/${qId}/${isT}`,
    );
  },
  /**
   * 获取未回答的课程数量
   * @param {Number} agencyId 机构ID
   * @param {String} courseIds 课程ID集合
   */
  getNotAnswerCount(agencyId, courseIds, userId) {
    return ajax.post(`/api/pc/questions/getQuestionIsresolved`, {
      agencyId,
      courseIds,
      userId,
    });
  },
  /**
   * 获取回答的提问未读数量
   * @param {*} userId
   */
  getQuestionNotReadCount(userId) {
    return ajax.get(`/api/pc/questions/getUserQuestionsNotReadCount`, {
      userId,
    });
  },
  /**
   * 获取用户提问[日期-个数]列表(答疑)（教师端）
   * @param {Object} query {agencyId,page,isResolved,isReport,isComment,courseIds}
   */
  getQuestionListWithDate(query) {
    return ajax.post(`/api/pc/questions/getmyquestionList`, query);
  },
  /**
   * 获取用户提问[课程-个数]列表（教师端）
   * @param {*} query {agencyId,isResolved,isReport,isComment,courseIds,datetime}
   */
  getQuestionListWithCourse(query) {
    return ajax.post(`/api/pc/questions/getQuestionCourse`, query);
  },
  /**
   * 获取问题列表（教师端）
   * @method getQuestionList
   * @param {Object} query
   * query: {
   *  agencyId: -1,
   *  page: 1,
   *  courseId: "",
   *  date: "",
   *  type: "",
   *  qId: 0
   * }
   */
  getQuestionList(query) {
    return ajax.post(`/api/pc/questions/getCourseQuestionList`, query);
  },
  /**
   * 获取视频详情（教师答疑）
   * @param {Number} pptId
   */
  getVideoInfo(pptId) {
    return ajax.get(`/api/pc/getpptDetails/${pptId}`);
  },
  /**
   * 标记/取消问题待详解（教师答疑）
   * @param {Number} qId 问题ID
   * @param {Number} isReport 0 || 1
   */
  markQuestionIsReport(qId, isReport) {
    return ajax.post(
      `/api/pc/questions/updateQuestionIsReport/${qId}/${isReport}`,
    );
  },
  /**
   * 订单管理
   * @param {*} userId 用户id
   */
  getMyOrder(userId) {
    return ajax.get(`/api/pc/getMyOrder/${userId}`);
  },
  /**
   * 删除订单
   * @param {Number} orderId
   */
  deleteOrder(orderId) {
    return ajax.post(`/api/pc/deleteMyOrder/${orderId}`);
  },
  /**
   * 我的积分
   * @method getMyIntegral
   * @param {Number} userId - 用户id
   * @return {返回值类型} 返回值说明
   */
  getMyIntegral(userId) {
    return ajax.get(`/api/pc/notice/Integral/${userId}`);
  },

  /**
   * 积分明细
   * @method getIntegralDetail
   * @param {Number} userId - 用户id
   * @return {返回值类型} 返回值说明
   */
  getIntegralDetail(userId) {
    return ajax.get(`/api/pc/notice/getIntegrationDetailByUserId/${userId}`);
  },
  /**
   * 用户签到
   * @param {Number} agencyId
   * @param {Number} userId
   */
  signIn(agencyId, userId) {
    return ajax.get(`/api/pc/notice/mySignIn/${agencyId}/${userId}`);
  },
  /**
   * 消息中心(普通消息)
   * @method getMyMsg
   * @param {Number} isRead - 1已读，0未读
   * @param {Number} userId - 用户id
   * @return {返回值类型} 返回值说明
   */
  getMessage(isRead, userId) {
    return ajax.get(`/api/pc/notice/list/${isRead}/${userId}`);
  },
  /**
   * 获取未读消息的数量
   * @param {Number} userId 用户ID
   */
  getNotMessageCount(userId) {
    return ajax.get(`api/pc/notice/getIsReadCount/${userId}`);
  },
  /**
   * 获取课程消息
   * @param {Number} isRead 1已读，0未读，-1全部
   * @param {Number} userId 用户Id
   * @param {Number} type -1全部 1课程更新 2串讲上线
   */
  getMessageWithCourse(isRead, userId, type) {
    return ajax.get(`/api/pc/notice/noticeList/${userId}/${isRead}/${type}`);
  },
  /**
   * 设置消息为已读
   * @param {Number} id 消息ID
   * @param {Number} type 1普通消息，2课程消息
   */
  setMessageReaded(id, type, userId = 0) {
    return ajax.get(
      `/api/pc/notice/updateNotice/${id}/${type}?userId=${userId}`,
    );
  },
  /**
   * 删除消息
   * @param {Number} id 消息ID
   * @param {Number} type 1普通消息，2课程消息
   */
  deleteMessage(id, type) {
    return ajax.get(`/api/pc/notice/deleteNotice/${id}/${type}`);
  },
  /**
   * 修改用户资料
   * @param {Object} data
   */
  updateUserInfo(data) {
    return ajax.post(`/api/pc/updateUsers`, data);
  },
  /**
   * 修改用户密码
   * @param {Object} data
   */
  updateUserPassword(data) {
    return ajax.post(`/api/pc/modifypassword`, data);
  },
  /**
   * 获取班级列表
   * @param {Number} agencyId 机构ID
   * @param {Number} userId
   */
  getClassList(agencyId, userId) {
    return ajax.get(`/api/pc/getUserGradeList`, { agencyId, userId });
  },
  /**
   * 获取班级详情
   * @param {String} gradeCode 班级代码
   */
  getClassInfo(gradeCode, userId) {
    return ajax.get(`/api/pc/getUserGradeDetails`, { gradeCode, userId });
  },
  /**
   * 获取班级内课程
   * @param {String} gradeCode 班级代码
   */
  getClassCourseList(gradeCode, userId) {
    return ajax.get(`/api/pc/getMongoCourseList`, { gradeCode, userId });
  },
  /**
   * 获取课程教材
   * @param {String} courseId
   */
  getClassTextbook(courseId) {
    return ajax.get(`/api/pc/getTchmaterialList`, { courseId });
  },
  /**
   * 获取缴费项目及是否已缴费
   * @param {String} gradeCode
   * @param {Number} userId
   */
  getClassPayItem(gradeCode, userId) {
    return ajax.get('/api/pc/getPayItemList', { gradeCode, userId });
  },
  /**
   * 获取学籍信息
   * @param {String} gradeCode
   * @param {Number} userId
   */
  getSchoolRollInfo(gradeCode, userId) {
    return ajax.get(`/api/pc/getSrfDetails`, {
      gradeCode,
      userId,
    });
  },
  /**
   * 获取证件信息
   * @param {int} srfId 学籍id
   * @param {int} type 类型 1：基础证件(身份证、个人照)2：其它证件
   */
  getPersonGrades(srfId, type) {
    return ajax.get(`/rest/selectGrades/${srfId}/${type}`);
  },
  /**
   * 保存用户上传的个人资料
   * @param {Number} srfId 学籍ID
   * @param {Number} agencyId 机构ID
   * @param {String} url 文件URL
   * @param {String} fileName 文件名
   * @param {String} name 原始文件名
   */
  savePersonFile(srfId, agencyId, url, fileName, name, size) {
    return ajax.post(`rest/addOtherGrades`, {
      srfid: srfId,
      agencyid: agencyId,
      url: url,
      filename: fileName,
      name,
      size,
    });
  },
  /**
   * 删除个人上传的资料
   * @param {int} id
   */
  deletePersonFile(id) {
    return ajax.post(`rest/delGrades/${id}`);
  },
  getExamScore(gradeCode, userId) {
    return ajax.get(`/result/getMyResult`, {
      gradeCode,
      userId,
    });
  },
  getExamCourseScore(gradeCode, userId, courseId) {
    return ajax.get(`/result/getCourseResult`, {
      gradeCode,
      userId,
      courseId,
    });
  },
  /**
   * 班级缴费项目缴费
   * @param {Number} agencyId
   * @param {Number} id 项目Id
   * @param {Number} userId 用户ID
   * @param {Number} gradeCode 班级代码
   */
  reqItemPay(agencyId, id, userId, gradeCode) {
    return ajax.post(`/api/pc/paySave`, {
      agencyId,
      id,
      userId,
      gradeNo: gradeCode,
    });
  },
  /**
   * 查询订单是否支付成功
   * @param {Number} orderId
   */
  getIsPaySuccess(orderId) {
    return ajax.get(`/api/pc/isPaySuccess`, { id: orderId });
  },
  /**
   * 删除未支付的订单
   * @param {Number} orderId 订单ID
   */
  deleteClassOrder(orderId) {
    return ajax.get(`/api/pc/deleteOrders`, { orderNo: orderId });
  },
  /**
   * 获取报考列表
   * @param {*} srfId 学籍ID
   */
  getExamList(srfId) {
    return ajax.get(`/api/pc/getMrMList/${srfId}`);
  },
  /**
   * 设置报考未付费提示为已提示过
   * @param {Number} mrmId 报考列表Id
   */
  setExamForIsNotice(mrmId) {
    return ajax.post(`/api/pc/updateMrmIsNotice/${mrmId}`);
  },
  /**
   * 获取报考中的课程列表
   * @param {*} mrmId 报考列表Id
   */
  getExamCourseList(mrmId) {
    return ajax.get(`/api/pc/getMCourseexamtimeListByMrmId/${mrmId}`);
  },
  /**
   * 获取报考考期
   * @param {*} srfId 学籍ID
   */
  getExamTermList(srfId) {
    return ajax.get(`/api/pc/getMPromaListByBuType/${srfId}`);
  },
  /**
   * 获取考期内课程
   * @param {*} srfId 学籍ID
   * @param {*} promaId 考期ID
   */
  getExamTermCourseList(srfId, promaId) {
    return ajax.get(
      `/api/pc/getMcourseListBySrfIdAndPromaId/${srfId}/${promaId}`,
    );
  },
  /**
   * 是否允许报考
   * @param {Number} srfId 学籍ID
   */
  getIsEnroll(srfId) {
    return ajax.get(`/api/pc/isMPromaTrue/${srfId}`);
  },
  /**
   * 添加报考
   * @param {Object} data 参数对象
   */
  addEnroll(data) {
    return ajax.post(`/api/pc/addMRM`, data);
  },
  /**
   * 修改报考信息
   * @param {Object} data 参数对象
   */
  editEnroll(data) {
    return ajax.post(`/api/pc/editMRM`, data);
  },
  /**
   * 报考缴费
   * @param {Number} mrmId 数据
   */
  enrollPaySave(mrmId) {
    return ajax.post(`/api/pc/mrmPaySave`, { id: mrmId });
  },
  /**
   * 获取我的毕业数据信息
   * @param {String} gradeCode 班级代码
   * @param {Number} userId 用户ID
   */
  getGraduateInfo(gradeCode, userId) {
    return ajax.get(`/graduation/getCourseResult`, { gradeCode, userId });
  },
  /**
   * 删除上传的毕业文件
   * @param {Number} id Id
   */
  deleteGraduateFile(id) {
    return ajax.post(`/graduation/delGraduateFile`, { id });
  },

  /**
   * 检查课程是否需要签约协议
   * @param {String} umcId
   */
  getAgreementCheckByCourse(data) {
    return ajax.get(`/agreement/check/order`, data);
  },

  /**
   * 获取已签约协议
   * @param {String} userId 用户ID
   */
  getAgreement(userId) {
    return ajax.get(`/agreement/user/record/list?userId=${userId}`);
  },

  /**
   * 获取待签约协议
   * @param {String} userId 用户ID
   */
  getNotAgreement(userId) {
    return ajax.get(`/agreement/user/record/list/notSign?userId=${userId}`);
  },

  /**
   * 获取待签约协议
   * @param {String} userId 用户ID
   * @param {String} agreementRecordId 协议ID
   */
  getAgreementDetail(data) {
    return ajax.get(`/agreement/user/record/detail`, data);
  },

  /**
   * 带token获取已签约协议的base64图片
   * @param {String} params.id - 协议id
   */
  getAgreementImg(data) {
    return ajax.get(`/agreement/signImg`, data);
  },

  /**
   * 修改用户名
   * @param {Object} data
   */
  updateUserName(data) {
    return ajax.post(`/api/pc/updateUserName`, data);
  },
};

//接口开课处理
export const api = {
  /**
   * 请求开课（通过课程）
   * @param {Number} agencyId 机构ID
   * @param {Object} data 请求数据
   */
  authWithCourse(agencyId, data) {
    return ajax.post(`/payment/courseApi/${agencyId}`, data);
  },
  /**
   * 请求开课（通过商品）
   * @param {*} data
   */
  authWithProduct(data) {
    return ajax.post(`api/pc/openCourse`, data);
  },
};
export const identity = {
  /**
   * 发送身份证号（通过商品）
   * @param {*} data
   */
  identityApi(data) {
    return ajax.post(`/order/bind/${data.userId}/${data.ticketNo}`, data);
  },
};

// 机构定制功能
export const custom = {
  /**
   * 获取班级列表（包括学籍ID）
   * @param {Number} agencyId 机构ID
   * @param {Number} userId 用户ID
   * @returns
   */
  getGradeList(agencyId, userId) {
    return ajax.get(
      `/api/pc/getGradeListByUserId?agencyId=${agencyId}&userId=${userId}`,
    );
  },
  /**
   * 获取课程列表
   * @returns
   */
  getCourseList(srfId, agencyId) {
    return ajax.get(`/api/pc/getStudyPlan?srfId=${srfId}&agencyId=${agencyId}`);
  },
  /**
   * 获取学员(学籍)信息
   * @returns
   */
  getSrfInfo(srfId) {
    return ajax.get(`/api/pc/getSrfInfo?srfId=${srfId}`);
  },
  /**
   * 获取网课列表（必过关联课程）
   * @param {Number} courseId 课程ID（教务里面的）
   * @returns
   */
  getStudyCourse(courseId) {
    return ajax.get(`api/pc/getCourseList?courseId=${courseId}`);
  },
  /**
   * 获取可考试(模考)的网课列表（必过关联课程）
   * @param {Number} courseId 课程ID（教务里面的）
   */
  getExamCourse(courseId) {
    return ajax.get(`api/pc/getSinExamRecList?courseId=${courseId}`);
  },
  /**
   * 获取考试时间
   * @returns
   */
  getExamDate(courseId, srfId) {
    return ajax.get(
      `api/pc/getSinExamRecTime?courseId=${courseId}&srfId=${srfId}`,
    );
  },
};

export const oem = {
  //获取模考信息及习题列表
  getSimExerciseList(simId) {
    return ajax.get(`/api/pc/getSimExamExerciseListBySimId/${simId}`);
  },
};
